module.exports = __webpack_public_path__ + "img/gamifinnator-yes.c7af93f6.png";